import { combineReducers } from "redux";

import mediaReducer from "./media-reducer";

const mediasReducer = combineReducers({
    media: mediaReducer,
});

export default mediasReducer;
